<app-loading-screen *ngIf="show">Loading Group data</app-loading-screen>
<app-loading-screen *ngIf="spinnersave">Saving Group data</app-loading-screen>
<app-loading-screen *ngIf="spinnergroupcopy">Copying Prior Year Group data</app-loading-screen>
<form [formGroup]="groupreportingform" class="group-form" (ngSubmit)="onsubmit()" *ngIf="groupreportloaded | async">
  <div style="float: right;display: flex;" *ngIf="(isgroupreporting && !isReadOnly)">
    <app-button *ngIf="isPrioryearCopyEnabled" size="medium" type="button" (click)="onprioryeargroupcopy()" (keyup)="onprioryeargroupcopy()" buttonType="secondary" style="margin-right: 15px;">Prior Year Group Copy</app-button>
    <app-button size="medium" type="submit" buttonType="primary" style="margin-right: 15px;" class="nocursor"
      [disabled]="!groupreportingform.valid || (groupreporting.length ==0 && !isDelete)">Save Data</app-button>
  </div>
  <div class="pagetitle">Group Reporting: {{ currentYear }}</div>
  <div *ngIf="compno!==null">
    <span class="pagetitleSecondLayerBold"> {{ prfNumber.toUpperCase() }} </span>:<span class="pagetitleSecondLayer">
      {{ prfName }}</span>
  </div>
  <div class="page-description">
    <i class="material-icons note-icon">info</i>
    <span class="note-text">
      This tab becomes available if you select “Yes” for group reporting. 
      This will allow you to select the companies you wish to include in this PRF,
       and asks you to provide their NAIC.
    </span>
</div>
  <br />
  <div>
    <div class="PageLevelError" *ngIf="showPageError">Either NAIC or AMBEST is required</div>
    <div class="PageLevelError" *ngIf="nvalError">Please enter a valid NAIC</div>
    <div class="PageLevelError" *ngIf="avalError">Please enter a valid AMBEST</div>
    <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">PDB Number</th>
          <th scope="col">Company</th>
          <th scope="col">Reported PRF</th>
          <th>NAIC</th>
          <th>AMBest</th>
          <th *ngIf="!isReadOnly"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of groupreporting;let row=index">
          <td>{{row+1}}</td>

          <td>{{item.No}}<span *ngIf="item.isAutoAdded" class="auto-added-marker">&nbsp;*</span>
            <input type="hidden" [(ngModel)]="item.No" formControlName="No_{{row}}" />
            <input type="hidden" [(ngModel)]="item.VisibleTo" formControlName="VisibleTo_{{row}}" />
            <input type="hidden" [(ngModel)]="item.chktext" formControlName="chktext_{{row}}" />
            <input type="hidden" [(ngModel)]="item.TakenBy" formControlName="TakenBy_{{row}}" />
          </td>

          <td>{{ item.Name }} <input type="hidden" [(ngModel)]="item.Name" formControlName="Name_{{row}}" />
          </td>
          <td class="titleBold">

            <ng-container *ngIf="item.chktext=='Include';else second">

              <div *ngIf="item.chkvalue ==false && (!isgroupreporting || isReadOnly)">
                <label class="customcheck" [ngClass]="{nocursort: isReadOnly}">
                  <div class="textstylenormal"> Include</div>
                  <span class="checkmarkgrayed"></span>
                </label>
              </div>  
              <div *ngIf="item.chkvalue ==false && isgroupreporting && !isReadOnly">
                <label class="customcheck" [ngClass]="{nocursort: isReadOnly}">
                  <input [attr.disabled]="isReadOnly ? 'true' : null" type="checkbox" [(ngModel)]="item.chkvalue"
                    checked='unchecked' (click)="onNativeChange($event,row)" (keydown)="onNativeChange($event,row)" formControlName="chkvalue_{{row}}" tabindex="0"/>
                  <div class="textstylenormal"> Include</div>
                  <span class="checkmark"></span>
                </label>
              </div>
              <div *ngIf="item.chkvalue ==true && isReadOnly">

                <label class="customcheck" [ngClass]="{nocursort: isReadOnly}">
                  <input disabled="true" type="checkbox" checked="checked"
                    [(ngModel)]="item.chkvalue"/>
                  <div class="textstylenormal"> Include</div>
                  <span class="checkmark"></span>
                </label>
              </div>
              <div *ngIf="item.chkvalue ==true && !isReadOnly && !isLocked && isgroupreporting">

                <label class="customcheck" [ngClass]="{nocursort: isReadOnly}">
                  <input disabled="false" type="checkbox" checked="checked"
                    [(ngModel)]="item.chkvalue" (click)="onNativeChange($event,row)" (keydown)="onNativeChange($event,row)" formControlName="chkvalue_{{row}}" tabindex="0"/>
                  <div class="textstylenormal"> Include</div>
                  <span class="checkmark"></span>
                </label>
              </div>

            </ng-container>
            <ng-template #second>

              <div>{{item.chktext}}</div>
            </ng-template>
            <ng-template #third></ng-template>


          </td>
          <td>


            <input [readonly]="isReadOnly" *ngIf="item.chkvalue == true" [(ngModel)]="item.NAIC"
              (keypress)="validateInput($event)" (keyup)="onchange()" style="text-align:right;height: 30px;"
              formControlName="NAIC_{{row}}" class="form-control input-sm" size="5" />
          </td>
          <td>
            <input [readonly]="isReadOnly" *ngIf="item.chkvalue == true" (keyup)="onchange()" [(ngModel)]="item.AMBest"
              (keypress)="validateInput($event)" style="text-align:right;height: 30px;" formControlName="AMBest_{{row}}"
              class="form-control input-sm" size="5" />
          </td>

          <td *ngIf="(isgroupreporting && !isReadOnly)">
            <div *ngIf="(item.TakenBy =='' || item.TakenBy ==compno)  && item.No.startsWith('NEW');else default"
              class='delete'>

              <span class="table-material-icons" (click)="deletegroupreport(item)" (keydown)="deletegroupreport(item)">delete</span>
            </div>

            <ng-template #default>
              <div class='delete_disabled'>
                <span class="table-material-icons">delete</span>
              </div>
            </ng-template>
          </td>
        </tr>

      </tbody>
    </table>

    <div *ngIf="hasAutoAddedCompany" class="auto-added-legend">
      <span class="auto-added-marker">*</span> This PRF doesn't exist in PDB and was added automatically to the list.
    </div>

  </div>
  <div *ngIf="(isgroupreporting && !isReadOnly)">
    <div *ngIf="hasGroupDetails" class='edit' style="float: right;" (click)="add()" (keydown)="add()"> <span
        class="table-material-icons">add</span> Add Row
    </div>
    <div *ngIf="!hasGroupDetails" class='edit_disabled' style="float: right;"
      ngbTooltip="Disabled since this company is not group reported in PDB" placement="left"
      tooltipClass="tooltip-class"> <span
        class="table-material-icons">add</span> Add Row
    </div>
  </div>
</form>
<app-confirm-dialog></app-confirm-dialog>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>